<template>
  <legend
    class="bv-no-focus-ring col-form-label pt-0"
  >
    <b-icon
      :icon="icon"
    />
      {{ text }}
  </legend>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },

    text: {
      type: String
    }
  }
}
</script>
